const recaptcha = {
    on: import.meta.env.VITE_APP_RECAPTCHA_ON === 'true',
    apiKeyRecaptchaV2:
        import.meta.env.VITE_APP_RECAPTCHA_V2_SITE_KEY ||
        '6LcBawAmAAAAAKvudDOzzQ87Ldp8geN77H6y6t66'
}

export default recaptcha
